import {
  dispatchAction,
  extractPayload,
  ofType,
  routine,
  withNamespace,
} from '@ardoq/rxbeach';
import { debounceTime, from, switchMap, tap } from 'rxjs';
import * as editTraversalActions from './traversals/editTraversalActions';
import { api, traversalApi } from '@ardoq/api';

export const getRequestFetchInstanceCountsRoutine = (namespace: string) =>
  routine(
    withNamespace(namespace),
    ofType(editTraversalActions.requestFetchInstanceCounts),
    extractPayload(),
    switchMap(payload =>
      from(traversalApi.countInstances(payload)).pipe(
        tap(response => api.logErrorIfNeeded(response))
      )
    ),
    tap(result =>
      dispatchAction(
        editTraversalActions.responseInstanceCounts(result),
        namespace
      )
    )
  );

export const getFetchOptionInstanceCountsRoutine = (namespace: string) =>
  routine(
    withNamespace(namespace),
    ofType(editTraversalActions.requestFetchOptionsInstanceCounts),
    extractPayload(),
    // It's safe to debounce here since the last request would always overwrite
    // the result of the previous one.
    debounceTime(32),
    switchMap(payload =>
      from(traversalApi.countInstances(payload)).pipe(
        tap(response => api.logErrorIfNeeded(response))
      )
    ),
    tap(result =>
      dispatchAction(
        editTraversalActions.responseOptionsInstanceCounts(result),
        namespace
      )
    )
  );
